import React from "react";
import { EBChant } from "../../chants/eb-chant/EBChant";

export interface NewHymnData {
    title: string;
    tune: string;
    text: string;
    mode: number;
    ep1Note?: string;
    ep2Note?: string;
    mpNote?: string;
    tweak?: number;
}

export const getHymnVerseGabc = (tune: string, text: string) => {
    try {
        const tuneLines = tune.split("\n").map((tl) => tl.trim());
        const verses = text.split("\n\n");

        return (
            `(${tuneLines[0]}) ` +
            verses
                .map((v) => {
                    const lines = v.split("\n").map((vl) => vl.trim());

                    return lines
                        .map((l, lineIndex) => {
                            const tuneSyllables =
                                tuneLines[lineIndex + 1]?.split(" ") ?? [];

                            return (
                                l
                                    .replace(/ /g, "_ ")
                                    .split("_")
                                    .map((syllable, syllableIndex) => {
                                        return `${syllable}(${
                                            tuneSyllables[syllableIndex] ?? ","
                                        })`;
                                    })
                                    .join("") +
                                ` (${tuneSyllables[tuneSyllables.length - 1]})`
                            );
                        })
                        .join(" ");
                })
                .join(" ")
        );
    } catch {
        return "";
    }
};

export const getHymnAutoTweak = (tune: string) => {
    let totalNoteValue = 0;
    let noteCount = 0;
    let minNote = 99;
    let maxNote = 0;

    for (let i = 1; i < tune.length; i++) {
        // skip c4 etc
        const char = tune.charAt(i);

        const alpha = "abcdefghijklmn";

        if (alpha.includes(char)) {
            const noteValue = alpha.indexOf(char);

            totalNoteValue += noteValue;
            noteCount++;

            minNote = Math.min(minNote, noteValue);
            maxNote = Math.max(maxNote, noteValue);
        }
    }

    const avgNote = Math.round(totalNoteValue / noteCount);
    const range = maxNote - minNote;

    let tweak = 4 - avgNote;
    const initialTweak = tweak;

    const topLimit = 12;
    const bottomLimit = 4;
    const rangeLimit = topLimit - bottomLimit;

    const rangeError = Math.max(range - rangeLimit, 0);

    const topError = Math.max(maxNote + tweak - topLimit, 0);
    const bottomError = Math.max(bottomLimit + tweak - minNote, 0);

    const allowedError = Math.round(rangeError / 2);

    if (topError > allowedError) {
        tweak -= topError - allowedError;
    }

    if (bottomError > allowedError) {
        tweak += bottomError - allowedError;
    }

    console.log("auto tweak", {
        avgNote,
        minNote,
        maxNote,
        range,
        effectiveAvg: avgNote + tweak,
        effectiveMin: minNote + tweak,
        effectiveMax: maxNote + tweak,
        topError,
        bottomError,
        rangeError,
        initialTweak,
        tweak,
        allowedError,
    });

    return tweak;
};

export const NewHymn: React.FC<{ hymn: NewHymnData }> = (props) => {
    const { hymn } = props;

    const verses = hymn.text.split("\n\n");

    return (
        <>
            {verses.map((verse, verseIndex) => {
                const gabc = getHymnVerseGabc(hymn.tune, verse);

                return (
                    <EBChant
                        gabc={gabc}
                        dropCap={verseIndex === 0}
                        tone={hymn.mode + ""}
                    />
                );
            })}
        </>
    );
};
